import TCompanyMgmt from './index.vue';

TCompanyMgmt.install = app => {
  app.component(TCompanyMgmt.name, TCompanyMgmt);
};

export default TCompanyMgmt;
